import isValidDate from './isValidDate';

type TDateInput = Date | string | number;

export const differenceInYear = (rawDate1: TDateInput, rawDate2: TDateInput): number => {
  const date1 = new Date(rawDate1);
  const date2 = new Date(rawDate2);

  if (!isValidDate(date1) || !isValidDate(date2)) {
    return -1;
  }

  const [earlier, later] = date1.getTime() <= date2.getTime() ? [date1, date2] : [date2, date1];

  let years = later.getFullYear() - earlier.getFullYear();

  const isAnniversaryReached =
    later.getMonth() > earlier.getMonth() ||
    (later.getMonth() === earlier.getMonth() && later.getDate() >= earlier.getDate());

  if (!isAnniversaryReached) {
    years -= 1;
  }

  return years;
};
